import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

export const socialData = [
  
  {
    id: 1,
    icon: <FaGithub className="icon" />,
    url: 'https://github.com/BonganiMaila'
  },
  {
    id: 2,
    icon: <FaLinkedin className="icon" />,
    url: 'https://www.linkedin.com/in/bongani-maila/'
  }
];
